import * as React from "react";
import { forwardRef } from "react";
const SvgEnlargeIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M11.3334 5.33333L8.00008 2L4.66675 5.33333M11.3334 10.6667L8.00008 14L4.66675 10.6667", stroke: "#8E8E93", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgEnlargeIcon);
export default ForwardRef;
